/* Built In Imports */
import React, { useState } from 'react';

/* External Imports */
import {
    AspectRatio,
    Box,
    Flex,
    Image,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    Text,
    useDisclosure,
} from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';
/* Services */

/**
 * Renders the Previews component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Previews component
 */

const Previews = ({ sectionContent, region, lang }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [youtubeurl, setYoutubeurl] = useState('');
  const previewData = sectionContent.body.find(
    el => el.sectionId == 'Section-2'
  );
  const previewVideolist = newUrl => {
    setYoutubeurl(newUrl);
    onOpen();
  };
  return (
    <Box>
      <Text
        fontSize={{ base: '12px', md: '16px' }}
        color="#ffbd31"
        margin="0 0 0 0"
        letterSpacing="1.5px"
        fontFamily="FedraSansStd-book"
        textTransform="uppercase"
      >
        {previewData.sectionContent[0]?.titleSubtext}
      </Text>
      <Text
        as="h2"
        fontSize={{ lg: '50px', base: '28px' }}
        fontFamily="FedraSansStd-A-medium"
      >
        {previewData.sectionContent[0]?.titleText}
      </Text>
      <Box
        display="flex"
        w={{ base: 'auto', lg: '1024px' }}
        m={{ base: '45px 0 0', sm: 'auto', lg: '45px auto 0' }}
        justifyContent={{ base: 'center', md: 'center' }}
      >
        <Flex
          display={{ base: 'block', sm: 'inherit' }}
          m={{ base: 'unset', sm: '0 0 0 15px', lg: 'unset' }}
        >
          <Box
            w={{ base: 'auto', sm: 'calc((100% - 72px) / 4)' }}
            margin={{ base: '0 0 29px 0', sm: '0 29px 0 0' }}
            position="relative"
          >
            <Box
              position="absolute"
              margin-left="calc((100% - 65px) / 2)"
              top={{ base: '45%', sm: '38%', lg: '45%' }}
              left={{ base: '0' }}
              right={{ base: '0' }}
              margin="0 auto"
              width={{ base: '50px', lg: '65px' }}
            >
              <Image
                src={`${config.imgPath}/d/46272/1644995290-play.png`}
                title="play"
                alt="play"
                // src="https://images.sadhguru.org/d/46272/1644995290-play.png"
                onClick={() =>
                  previewVideolist(`${previewData.sectionContent[1]?.fieldId}`)
                }
                cursor="pointer"
              />
            </Box>
            <Box
              bgImage={{
                sm: `url('${previewData.sectionContent[1]?.image.url}')`,
                base: `url('${previewData.sectionContent[1]?.mobileImage?.url}')`,
              }}
              backgroundSize="100%"
              backgroundRepeat="no-repeat"
              borderRadius="8px"
              width={{
                base: '340px',
                sm: '152px',
                lg: '238px',
                '2xl': '333px',
              }}
              height={{
                base: '209px',
                sm: '188px',
                lg: '296px',
                '2xl': '414px',
              }}
            ></Box>
          </Box>
          <Box
            w={{ base: 'auto', sm: 'calc((100% - 72px) / 4)' }}
            margin={{ base: '0 0 29px 0', sm: '0 29px 0 0' }}
            position="relative"
          >
            <Box
              position="absolute"
              margin-left="calc((100% - 65px) / 2)"
              top={{ base: '45%', sm: '38%', lg: '45%' }}
              left={{ base: '0' }}
              right={{ base: '0' }}
              margin="0 auto"
              width={{ base: '50px', lg: '65px' }}
            >
              <Image
                src={`${config.imgPath}/d/46272/1644995290-play.png`}
                title="play"
                alt="play"
                // src="https://images.sadhguru.org/d/46272/1644995290-play.png"
                onClick={() =>
                  previewVideolist(`${previewData.sectionContent[2]?.fieldId}`)
                }
                cursor="pointer"
              />
            </Box>
            <Box
              bgImage={{
                sm: `url('${previewData.sectionContent[2]?.image.url}')`,
                base: `url('${previewData.sectionContent[2]?.mobileImage?.url}')`,
              }}
              backgroundSize="100%"
              backgroundRepeat="no-repeat"
              borderRadius="8px"
              width={{
                base: '340px',
                sm: '152px',
                lg: '238px',
                '2xl': '333px',
              }}
              height={{
                base: '209px',
                sm: '188px',
                lg: '296px',
                '2xl': '414px',
              }}
            ></Box>
          </Box>
          <Box
            w={{ base: 'auto', sm: 'calc((100% - 72px) / 4)' }}
            margin={{ base: '0 0 29px 0', sm: '0 29px 0 0' }}
            position="relative"
          >
            <Box
              position="absolute"
              margin-left="calc((100% - 65px) / 2)"
              top={{ base: '45%', sm: '38%', lg: '45%' }}
              left={{ base: '0' }}
              right={{ base: '0' }}
              margin="0 auto"
              width={{ base: '50px', lg: '65px' }}
            >
              <Image
                src={`${config.imgPath}/d/46272/1644995290-play.png`}
                title="play"
                alt="play"
                // src="https://images.sadhguru.org/d/46272/1644995290-play.png"
                onClick={() =>
                  previewVideolist(`${previewData.sectionContent[3]?.fieldId}`)
                }
                cursor="pointer"
              />
            </Box>
            <Box
              bgImage={{
                sm: `url('${previewData.sectionContent[3]?.image.url}')`,
                base: `url('${previewData.sectionContent[3]?.mobileImage?.url}')`,
              }}
              backgroundSize="100%"
              backgroundRepeat="no-repeat"
              borderRadius="8px"
              width={{
                base: '340px',
                sm: '152px',
                lg: '238px',
                '2xl': '333px',
              }}
              height={{
                base: '209px',
                sm: '188px',
                lg: '296px',
                '2xl': '414px',
              }}
            ></Box>
          </Box>
          <Box
            w={{ base: 'auto', sm: 'calc((100% - 72px) / 4)' }}
            margin={{ base: '0 0 29px 0', sm: '0 29px 0 0' }}
            position="relative"
          >
            <Box
              position="absolute"
              margin-left="calc((100% - 65px) / 2)"
              top={{ base: '45%', sm: '38%', lg: '45%' }}
              left={{ base: '0' }}
              right={{ base: '0' }}
              margin="0 auto"
              width={{ base: '50px', lg: '65px' }}
            >
              <Image
                src={`${config.imgPath}/d/46272/1644995290-play.png`}
                title="play"
                alt="play"
                // src="https://images.sadhguru.org/d/46272/1644995290-play.png"
                onClick={() =>
                  previewVideolist(`${previewData.sectionContent[4]?.fieldId}`)
                }
                cursor="pointer"
              />
            </Box>
            <Box
              bgImage={{
                sm: `url('${previewData.sectionContent[4]?.image.url}')`,
                base: `url('${previewData.sectionContent[4]?.mobileImage?.url}')`,
              }}
              backgroundSize="100%"
              backgroundRepeat="no-repeat"
              borderRadius="8px"
              width={{
                base: '340px',
                sm: '152px',
                lg: '238px',
                '2xl': '333px',
              }}
              height={{
                base: '209px',
                sm: '188px',
                lg: '296px',
                '2xl': '414px',
              }}
            ></Box>
          </Box>
          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay bgColor="black" />
            <ModalContent bgColor="transparent" maxW="720px">
              <ModalCloseButton
                top={{ base: '-34px', md: '-38px', lg: '-20px' }}
                right={{ base: '12px', md: '8px', lg: '-70px' }}
                color="#fff"
                fontSize={{ base: '18px', md: '24px', lg: '24px' }}
                _focus={{
                  boxShadow: 'none',
                }}
              />
              <ModalBody
                p="0"
                m={{ base: '0 10px', md: '0', lg: '20px 0 0 0' }}
              >
                <AspectRatio>
                  <iframe
                    src={`https://www.youtube.com/embed/${youtubeurl}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ 'z-index': '1' }}
                    width="auto"
                  ></iframe>
                </AspectRatio>
              </ModalBody>
            </ModalContent>
          </Modal>
        </Flex>
      </Box>
    </Box>
  );
};

export default Previews;
